import React from "react";
import moment from "moment";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";

export default function VoucherDetailContent({ viewCustomer, voucherDetails }) {
  const isActive = voucherDetails?.Voucher_Status_Id === 2; // example: 2 = Active

  const statusStyles = {
    1: "bg-blue-100 text-blue-800 border-blue-200",       // Draft/Pending
    2: "bg-emerald-100 text-emerald-800 border-emerald-200", // Active
    3: "bg-amber-100 text-amber-800 border-amber-200",     // Pending/Processing
    4: "bg-rose-100 text-rose-800 border-rose-200",        // Expired/Rejected
    5: "bg-purple-100 text-purple-800 border-purple-200",  // Redeemed
    6: "bg-gray-100 text-gray-700 border-gray-200",        // Cancelled
    7: "bg-orange-100 text-orange-800 border-orange-200",  // Processing
  };

  const statusBadge = (
    <span
      className={`inline-flex items-center px-4 py-1.5 rounded-full text-sm font-medium border ${
        statusStyles[voucherDetails?.Voucher_Status_Id] || "bg-gray-100 text-gray-700 border-gray-200"
      }`}
    >
      {voucherDetails?.Voucher_Status_Name || "Unknown"}
    </span>
  );

  return (
    <div className="space-y-8">
      {/* Corporate / Customer Information */}
      <section className="bg-white rounded-xl border shadow-sm overflow-hidden">
        <div className="px-6 py-5 border-b bg-gray-50 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-gray-900">
            Corporate & Customer Information
          </h2>
          {statusBadge}
        </div>

        <div className="p-6 lg:p-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-sm">
            <div className="space-y-1">
              <dt className="text-gray-600 font-medium">Corporate Name</dt>
              <dd className="text-gray-900 font-semibold">
                {voucherDetails?.Corporate_Name || "—"}
              </dd>
            </div>

            <div className="space-y-1">
              <dt className="text-gray-600 font-medium">Customer Name</dt>
              <dd
                className="text-indigo-600 hover:underline cursor-pointer font-medium"
                onClick={() => viewCustomer(voucherDetails?.Customer_Id)}
              >
                {voucherDetails?.Customer_Full_Name || "—"}
              </dd>
            </div>

            <div className="space-y-1">
              <dt className="text-gray-600 font-medium">Customer Email</dt>
              <dd
                className="text-indigo-600 hover:underline cursor-pointer break-words font-medium"
                onClick={() => viewCustomer(voucherDetails?.Customer_Id)}
              >
                {voucherDetails?.Customer_Email_Address || "—"}
              </dd>
            </div>

            <div className="space-y-1">
              <dt className="text-gray-600 font-medium">Customer Mobile</dt>
              <dd className="text-gray-900 font-medium">
                {voucherDetails?.Customer_Mobile_No || "—"}
              </dd>
            </div>

            <div className="space-y-1">
              <dt className="text-gray-600 font-medium">Voucher Type</dt>
              <dd className="text-gray-900 font-medium">
                {voucherDetails?.Voucher_Type_Name || "—"}
              </dd>
            </div>

            <div className="space-y-1">
              <dt className="text-gray-600 font-medium">Created By</dt>
              <dd className="text-gray-900 font-medium">
                {voucherDetails?.Created_By_Name || "—"}
              </dd>
            </div>

            <div className="space-y-1">
              <dt className="text-gray-600 font-medium">Transaction Date</dt>
              <dd className="text-gray-900 font-medium">
                {voucherDetails?.Transaction_Date
                  ? moment(voucherDetails.Transaction_Date).format("MMMM D, YYYY • h:mm A")
                  : "—"}
              </dd>
            </div>
          </div>
        </div>
      </section>

      {/* Voucher Information */}
      <section className="bg-white rounded-xl border shadow-sm overflow-hidden">
        <div className="px-6 py-5 border-b bg-gray-50">
          <h2 className="text-lg font-semibold text-gray-900">
            Voucher Information
          </h2>
        </div>

        <div className="p-6 lg:p-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-sm">
            <div className="space-y-1">
              <dt className="text-gray-600 font-medium">Voucher Code</dt>
              <dd className="text-indigo-700 font-bold font-mono tracking-wide">
                {voucherDetails?.Voucher_Number || "—"}
              </dd>
            </div>

            <div className="space-y-1">
              <dt className="text-gray-600 font-medium">Amount / Unit</dt>
              <dd className="text-emerald-700 font-semibold">
                ₦{formatCustomNumber(voucherDetails?.Voucher_Amount) || "0.00"}
              </dd>
            </div>

            <div className="space-y-1">
              <dt className="text-gray-600 font-medium">Recipient Name</dt>
              <dd className="text-gray-900 font-medium">
                {voucherDetails?.Reciepient_Name || "—"}
              </dd>
            </div>

            <div className="space-y-1">
              <dt className="text-gray-600 font-medium">Recipient Mobile</dt>
              <dd className="text-gray-900 font-medium">
                {voucherDetails?.Reciepient_Mobile_Number || "—"}
              </dd>
            </div>

            <div className="space-y-1">
              <dt className="text-gray-600 font-medium">Redeemed By</dt>
              <dd className="text-gray-900 font-medium">
                {voucherDetails?.Redeem_By_Name || "—"}
              </dd>
            </div>

            <div className="space-y-1">
              <dt className="text-gray-600 font-medium">Redeem Date</dt>
              <dd className="text-gray-900 font-medium">
                {voucherDetails?.Redeem_Date
                  ? moment(voucherDetails.Redeem_Date).format("MMMM D, YYYY • h:mm A")
                  : "—"}
              </dd>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}